// gui/dlg/dlgregister.js
//
// Registers the concrete dialog classes with the PSA singleton (see
// PSA.registerDialogClass / PSA._dialogClasses).
//
// This exists because PSA no longer imports the dialog classes directly: the dialogs
// extend ClientDialog, which transitively imports PSA, so a static psa -> dialog import
// would place each dialog in PSA's import cycle and risk a temporal-dead-zone crash on
// its `extends` (see the CRM-1097 MnuObj case). Since PSA was previously the ONLY
// importer of these dialog modules, something else must pull them in and register them.
//
// NOTE: this must export a function that init.js actually calls (mirroring
// widgets/wdgregister.js). A bare side-effect `import './CpyClpCfd'` is NOT enough:
// Rollup's tree-shaking prunes modules whose exports are never used, dropping the
// registration entirely. Referencing the classes inside an exported, called function
// keeps them in the bundle.

import PSA from '../../psa';
import CpyClpCfd from './CpyClpCfd';
import DlgCleanupDlg from './DlgCleanupDlg';

/**
 * registers all concrete dialog classes with the PSA singleton so its factory methods
 * (cpyClpCfd, dlgCleanupDlg, ...) can create them without a static psa -> dialog import
 */
export default function registerAllDialogs() {
	PSA.registerDialogClass( 'CpyClpCfd', CpyClpCfd );
	PSA.registerDialogClass( 'DlgCleanupDlg', DlgCleanupDlg );
}
